// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"18":"7cf0cea4d8575fc8","386":"439d0464c705ef28"}[chunkId] + ".js";
};